import { useContext, useState } from 'react';
import { createContext } from 'react';

import { DisclosureLayoutProps } from '../@types/DisclosureLayoutProps';

interface DisclosureLayoutContextProps extends DisclosureLayoutProps {
	isOpen: boolean;
	setIsOpen: (arg: boolean) => void;
}

export const DisclosureLayoutContext = createContext<DisclosureLayoutContextProps>({} as DisclosureLayoutContextProps);

DisclosureLayoutContext.displayName = 'DisclosureLayout';

const DisclosureLayoutProvider = (props: DisclosureLayoutProps) => {
	const [isOpen, setIsOpen] = useState(props.initialVisibility == 'visible' ? true : false);
	return (
		<DisclosureLayoutContext.Provider value={{ ...props, isOpen, setIsOpen }}>
			{props.children}
		</DisclosureLayoutContext.Provider>
	);
};

export const useDisclosureLayout = () => {
	const context = useContext(DisclosureLayoutContext);

	return context;
};

export default DisclosureLayoutProvider;
